import React from "react";
import { useNavigate } from "react-router-dom";
import "./FooterSection.css";
import { FaLinkedin } from "react-icons/fa";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="footer-links">
          <h4>Quick Links</h4>
          <ul>
            <li onClick={() => { navigate('/careers'); setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 300); }}>
              Careers
            </li>
            <li onClick={() => { navigate('/'); setTimeout(() => document.getElementById('whychooseus')?.scrollIntoView({ behavior: 'smooth' }), 300); }}>
              Why Choose Us
            </li>
            <li onClick={() => { navigate('/'); setTimeout(() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' }), 300); }}>
              Contact
            </li>
            <li onClick={() => { navigate('/aboutus'); setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 300); }}>
              About Us
            </li>
          </ul>
        </div>

        <div className="footer-contact">
          <h4>Contact</h4>
          <p className="footer-contact-address">B1, Building No 50, Block-C Sec-6, Noida, Uttar Pradesh – 201301</p>
          <p className="footer-contact-short">Noida, UP – 201301</p>
          <p className="footer-contact-phone-email">
            <a href="tel:+919650481240">+91 9650481240</a>
            <span className="footer-contact-sep"> · </span>
            <a href="mailto:info@adamanthr.com">info@adamanthr.com</a>
          </p>
        </div>

        <div className="footer-social">
          <a href="https://www.linkedin.com/company/adamanthr/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <FaLinkedin />
          </a>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2025 Adamant HR</p>
        <div className="footer-legal">
          <a href="/">Terms & Conditions</a>
          <a href="/">Privacy Policy</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
